export const LOCAL_STORAGE_KEYS = {
  TOKEN: "TOKEN",
  KEEP_ME_LOGGED_IN: "KEEP_ME_LOGGED_IN",
  SELECTED_LANGUAGE: "SELECTED_LANGUAGE",
  SIDE_BAR_MODE: "SIDE_BAR_MODE",
};
